import { defineAsyncComponent } from 'vue';
import { TIMESHEET_SETTINGS_TABS } from './components/TimesheetSettingsPage/constants';

export const timesheetSettingsPageFrontends = {
	TimesheetSettingsPage: defineAsyncComponent(
		() => import('./components/TimesheetSettingsPage')
	),
};

export const timesheetSettingsRoutes = [
	{
		path: `/settings/timesheetSettings/time-locking`,
		name: TIMESHEET_SETTINGS_TABS.TIMELOCKING,
		component: () => import('./components/TimesheetSettingsPage'),
	},
	{
		path: `/settings/timesheetSettings/time-locking-bulk-actions`,
		name: TIMESHEET_SETTINGS_TABS.TIMELOCKING_BULK_ACTIONS,
		component: () => import('./components/TimesheetSettingsPage'),
	},
	{
		path: `/settings/timesheetSettings/time/:pathMatch(.*)`,
		redirect: `/settings/timesheetSettings/time-locking-bulk-actions`,
	},
	{
		path: `/settings/timesheetSettings/:pathMatch(.*)?`,
		redirect: `/settings/timesheetSettings/time-locking`, // Default to timelocking
	},
];
